import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { MedicalFeePaymentEditInfo } from '../../model/medical-fee/medical-fee-payment-edit-info';
import { MedicalFeeAmount } from '../../model/medical-fee/medical-fee-amount';
import { MedicalFeePaymentManualSearchItem } from '../../model/medical-fee/medical-fee-payment-manual-search-item';

@Injectable({
  providedIn: 'root'
})
export class MedicalFeePaymentManualService {

  constructor( private dataService: DataService ) { }

  private readonly getMedicalFeePaymentEditInfoEndPoint: string =
          '/medicalFeePaymentManual/getMedicalFeePaymentEditInfo/';

  private readonly createMedicalFeeBillEndPoint: string =
          '/medicalFeePaymentManual/createMedicalFeeBill/';

  private readonly getMedicalFeePaymentManualSearchItemsEndPoint: string =
          '/medicalFeePaymentManual/getMedicalFeePaymentManualSearchItems/';

  private readonly cancelMedicalFeeBillEndPoint: string =
          '/medicalFeePaymentManual/cancelMedicalFeeBill/';

  async getMedicalFeePaymentManualSearchItems(  number?: number,
    physicianId?: number, payDateFrom?: Date, payDateTo?: Date,
    medicalFeePeriodId?: number ): Promise<MedicalFeePaymentManualSearchItem[]> {

    let toUtc = '';
    let fromUtc = '';

    if ( payDateFrom ) {
      fromUtc = new Date(payDateFrom.getFullYear(),
      payDateFrom.getMonth(), payDateFrom.getDate()).toDateString();
    }

    if ( payDateTo ) {
      toUtc = new Date(payDateTo.getFullYear(),
      payDateTo.getMonth(), payDateTo.getDate()).toDateString();
    }

    const param = {
      number,
      physicianId,
      payDateFrom: fromUtc,
      payDateTo: toUtc,
      medicalFeePeriodId
    };

    return await this.dataService
          .get<MedicalFeePaymentManualSearchItem[]>(this.getMedicalFeePaymentManualSearchItemsEndPoint,
            param).toPromise();
  }

  async getMedicalFeePaymentEditInfo(): Promise<MedicalFeePaymentEditInfo> {

    const param = {  };
    return await this.dataService
          .get<MedicalFeePaymentEditInfo>(this.getMedicalFeePaymentEditInfoEndPoint,
            param).toPromise();
  }
 
  async createMedicalFeeBill( medicalFeePaymentEditInfo: MedicalFeePaymentEditInfo ):
    Promise<boolean> {

    return await this.dataService.post<boolean>(this.createMedicalFeeBillEndPoint,
      medicalFeePaymentEditInfo).toPromise();
  }

  async cancelMedicalFeeBill( medicalFeeBillManualId: number ): Promise<boolean> {

    const param = { Id: medicalFeeBillManualId };
    return await this.dataService.post<boolean>(this.cancelMedicalFeeBillEndPoint,
      param).toPromise();
  }
}
